import { Text, textColors, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { eachDayOfInterval, endOfWeek, startOfWeek } from 'date-fns';
import { formatWeekdayName, type Locale } from '../../utils/calendarLocales';

const calendarHeaderDays = css`
  background-color: ${vars.colors.surface.primary};
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  inset-block-start: -1px;
  margin-inline: 4px;
  padding-block-end: 8px;
  position: sticky;
  z-index: 10;
`;

const calendarHeaderDay = css`
  text-align: center;
`;

interface DaysHeaderProps {
  locale?: Locale;
}

const DaysHeader = ({ locale }: DaysHeaderProps) => {
  const now = new Date();

  const days = eachDayOfInterval({
    start: startOfWeek(now, { locale }),
    end: endOfWeek(now, { locale }),
  }).map((day) => formatWeekdayName(day, { locale }));

  return (
    <div className={calendarHeaderDays} data-testid="calendar-days-header">
      {days.map((day) => (
        <Text
          className={calendarHeaderDay}
          color={textColors.PRIMARY}
          data-testid="calendar-days-header-day"
          key={day?.toString()}
          variant="14"
        >
          {day}
        </Text>
      ))}
    </div>
  );
};

export default DaysHeader;
